/** A stored JSON object, or null. */
export function readStoredRecord(
  value: unknown
): Record<string, unknown> | null {
  return typeof value === "object" && value !== null && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}
